










import { Component, Vue } from "vue-property-decorator";
import MainMenu from "@/components/Menu.vue";
import AppStore from "@/store/AppStore";

@Component({
  components: {
    MainMenu
  }
})
export default class App extends Vue {
  public get isMenuVisible() {
    const isMenuVisible = AppStore.menuVisible;

    // if (isMenuVisible) {
    //   document.body.classList.add('menu-visible');
    // document.body.style.height = window.innerHeight + 'px';
    // } else {
    // document.body.classList.remove('menu-visible');
    //  document.body.style.height = 'auto';
    // }
    
    return isMenuVisible;
  }
}
